import MainFiltersBQ from "../../../../Global/Models/Filters/MainFiltersBQ";

export default class StandingGameRankingsFilters extends MainFiltersBQ {}
